
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "GetQuoteBlock",

  computed: {
    imagePlaceholderPath: function () {
      if (!this.values.image) {
        return null
      }
      return this.$img(String(this.values.image), {
        height: 360
      })
    }
  },

  methods: {
    getSvgUrl: function (iconId) {
      return this.extras?.icons?.[iconId] || null
    }
  }
})
